import { render, staticRenderFns } from "./LogicPuzzle.vue?vue&type=template&id=14278f20&scoped=true&"
import script from "./LogicPuzzle.vue?vue&type=script&lang=js&"
export * from "./LogicPuzzle.vue?vue&type=script&lang=js&"
import style0 from "./LogicPuzzle.vue?vue&type=style&index=0&id=14278f20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14278f20",
  null
  
)

export default component.exports